import {Component, Object3D, TextComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export class CrimeDocProgress extends Component {
    static TypeName = 'crime-doc-progress';

    @property.object({required: true})
    textObject!: Object3D;

    updateNumber(crimeDocNum: number) {
        // first document is the photo, we don't count that.
        const displayValue = Math.max(crimeDocNum - 1, 0);

        this.textObject.getComponent(
            TextComponent
        )!.text = `${displayValue} / 5 documents found`;
    }
}
